import React from "react";
import { Quote } from "lucide-react";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  quote: "The attention to detail in the permit drawings was exceptional. We got our approval faster than expected thanks to their thoroughness.",
  author: "Sarah Jenkins",
  role: "Homeowner"
}, {
  quote: "Professional, reliable, and incredibly knowledgeable about local building codes. The consulting advice saved us thousands on our renovation.",
  author: "Michael Ross",
  role: "Property Developer"
}, {
  quote: "I've worked with many inspectors, but the level of clarity in their reports is unmatched. Highly recommended for anyone needing peace of mind.",
  author: "Elena Rodriguez",
  role: "Real Estate Agent"
}];
export default function ClientTestimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}